var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid py-5"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-12 py-5"},[_c('div',{staticClass:"animationWrapper"},[_c('LottieAnimation',{ref:"anim",attrs:{"animation-data":_vm.pageLoader,"auto-play":true,"loop":true,"speed":2}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }